<template>
  <div class="order_detail">
    <div class="card">
      <div class="title">订单评价</div>
      <div class="base">
        <div class="header">
          <div class="left">
            <div class="name">{{title}}</div>
            <div class="status">状态：<span class="error">{{status_name}}</span></div>
          </div>
          <div class="right">
            <!--            <Button type="primary" size="small">修改订单</Button>-->
            <Button class="cancel" size="small" v-if="status < 4" @click="cancel()">取消订单</Button>
          </div>
        </div>
        <div class="info">
          <span>客户：{{nickname}}</span>
          <span>订单编号：{{order_no}}</span>
          <span>下单时间：{{created_at}}</span>
          <span v-if="end_date != ''">支付截止时间：{{end_date}}</span>
        </div>
      </div>
    </div>
    <div class="block"></div>

    <div class="btn-grounp" style="padding: 20px;">
      <Form class="form" label-position="top">

        <div class="evaluate-score">
          <div class="score-section">
            <div class="score-section-title">订单评价</div>
            <div class="score-row">
              <span class="required">*</span>
              <span class="score-label">订单评价:</span>
              <div class="flower-rate">
                <span
                  class="flower-rate-item"
                  :class="{active: formItem.order_star >= item}"
                  v-for="item in 5"
                  :key="'order_' + item"
                  @click="setOrderStar(item)">
                  <flower-icon />
                </span>
              </div>
            </div>
          </div>

          <div class="score-section">
            <div class="score-section-title">师傅评价</div>
            <div class="score-row">
              <span class="required">*</span>
              <span class="score-label">师傅综合评价:</span>
              <RadioGroup class="overall-radio" v-model="formItem.worker_star" @on-change="changeWorkerStar">
                <Radio label="5">
                  <span class="bouquet-icon">
                    <flower-icon />
                  </span>
                  <span>好评</span>
                </Radio>
                <Radio label="3">
                  <span class="bouquet-icon">
                    <flower-icon />
                  </span>
                  <span>中评</span>
                </Radio>
                <Radio label="1">
                  <span class="bouquet-icon">
                    <flower-icon />
                  </span>
                  <span>差评</span>
                </Radio>
              </RadioGroup>
            </div>

            <div class="score-title">
              <span class="required">*</span>
              <span>请给师傅整体表现打分</span>
            </div>
            <div class="score-row" v-for="item in workerScoreFields" :key="item.key">
              <span class="score-label">{{ item.label }}:</span>
              <div class="flower-rate">
                <span
                  class="flower-rate-item"
                  :class="{active: formItem[item.key] >= star}"
                  v-for="star in 5"
                  :key="item.key + '_' + star"
                  @click="setWorkerStar(item.key, star)">
                  <flower-icon />
                </span>
              </div>
            </div>
          </div>
        </div>

        <FormItem label="评价">
          <Input v-model="formItem.evaluate" maxlength="200" type="textarea" :autosize="{minRows: 2,maxRows: 5}"
            placeholder="请输入评价内容"></Input>
        </FormItem>

        <FormItem label="图片:">
          <Upload :max='5' :more.sync=img_more :imgList.sync="formItem.img"></Upload>
          <div class="tips">最多可上传5张图片</div>
        </FormItem>

        <div class="footer">
          <Button class="pay-btn" type="primary" @click="payment()" style="width: 100px">立即提交</Button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import HeaderComponents from '../../../components/header'
import MasterItem from './components/master-item'
import cancelOrder from '../../../components/cancel-order'
import tabNav from '../../../components/tabNav'
import Upload from '../../../components/upload'

const FlowerIcon = {
  functional: true,
  render (h) {
    return h('svg', {
      attrs: {
        viewBox: '0 0 24 24',
        'aria-hidden': 'true'
      }
    }, [
      h('path', {
        class: 'star-shape',
        attrs: {
          d: 'M12 3.1l2.7 5.5 6.1.9-4.4 4.3 1 6.1-5.4-2.9-5.4 2.9 1-6.1-4.4-4.3 6.1-.9L12 3.1z'
        }
      })
    ])
  }
}

export default {
  name: 'order_detail',
  components: {
    HeaderComponents,
    MasterItem,
    tabNav,
    Upload,
    FlowerIcon
  },

  activated () {
    let vm = this
    let id = this.$route.params.id
    vm.id = id
    console.log(id)
    this.$request('6120ad9af2b9b', {
      order_id: id
    }).then(res => {
      console.log(res)
      vm.order_no = res.data.data.base.number
      vm.nickname = res.data.data.base.nickname
      vm.created_at = res.data.data.base.created_at
      vm.status_name = res.data.data.msg
      vm.initial_price = res.data.data.initial_price
      vm.price = res.data.data.price
      vm.status = res.data.data.status

      if (res.data.data.end_date != '' && res.data.data.end_date != undefined && res.data.data.end_date != null) {
        vm.end_date = res.data.data.end_date
      }

      vm.order_type = res.data.data.order_type
      vm.title = res.data.data.title

      vm.address.name = res.data.data.address.name
      vm.address.address = res.data.data.address.address
      vm.address.floor = res.data.data.address.floor
      vm.address.phone = res.data.data.address.phone
      vm.address.third = res.data.data.third

      vm.other.contact = res.data.data.other.contact
      vm.other.hope_complete = res.data.data.other.hope_complete

      if (res.data.data.logistics != null && res.data.data.logistics != undefined && res.data.data.logistics !=
          '') {
        vm.logistics.address = res.data.data.logistics.address
        vm.logistics.arrive = res.data.data.logistics.arrive
        vm.logistics.freight = res.data.data.logistics.freight
        vm.logistics.logistics_number = res.data.data.logistics.logistics_number
        vm.logistics.package_number = res.data.data.logistics.package_number
        vm.logistics.company = res.data.data.logistics.company
        vm.logistics.phone = res.data.data.logistics.phone
        vm.logistics.has = true
      } else {
        vm.logistics.has = false
      }

      if (res.data.data.worker != null && res.data.data.worker != undefined && res.data.data.worker != '') {
        vm.worker_id = res.data.data.worker.worker_id
      }

      if (vm.order_type == 1) {
        this.$request('612349bfeff78', {
          order_id: id,
          page: 1,
          size: 100000
        }).then(res => {
          vm.offer_all = res.data.data.count
          vm.offer_data = res.data.data.list

          console.log(res)
        })
      }
    })
  },
  data () {
    return {
      img_more: true,
      formItem: {
        type: '',
        evaluate: '',
        worker_star: 0,
        order_star: 0,
        book_star: 0,
        skill_star: 0,
        attitude_star: 0,
        service_star: 0,
        img: []
      },
      workerScoreFields: [{
        key: 'book_star',
        label: '预约评分'
      },
      {
        key: 'skill_star',
        label: '技能评分'
      },
      {
        key: 'attitude_star',
        label: '态度评分'
      },
      {
        key: 'service_star',
        label: '服务评分'
      }
      ],
      payTypeList: [{
        value: 'balance',
        label: '余额支付'
      },
      {
        value: 'wechatpc',
        label: '微信支付'
      }
      ],
      step: 1,
      timer: null,
      order_type: 1,
      id: 0,
      worker_id: 0,
      initial_price: 0,
      price: 0,
      offer_data: [],
      offer_all: 0,
      order_no: '',
      status_name: '',
      end_date: '',
      status: 0,
      nickname: '',
      title: '',
      created_at: '',
      logistics: {
        has: true,
        address: '',
        arrive: '',
        freight: 0,
        logistics_number: '',
        package_number: '',
        phone: '',
        company: ''
      },
      other: {
        contact: '',
        hope_complete: ''
      },
      address: {
        name: '',
        address: '',
        floor: '',
        phone: '',
        third: ''
      },
      columns: [{
        title: '商品图片',
        key: 'name',
        render: (h, parms) => {
          return h('img', {
            attrs: {
              src: 'https://iknow-pic.cdn.bcebos.com/810a19d8bc3eb135a9168029b41ea8d3fc1f444a?x-bce-process=image/quality,q_80'
            },
            style: {
              width: '60px',
              margin: '10px 0'
            }
          })
        }
      },
      {
        title: '安装环境图',
        key: 'age',
        render: (h, parms) => {
          return h('img', {
            attrs: {
              src: 'https://iknow-pic.cdn.bcebos.com/810a19d8bc3eb135a9168029b41ea8d3fc1f444a?x-bce-process=image/quality,q_80'
            },
            style: {
              width: '60px',
              margin: '10px 0'
            }
          })
        }
      },
      {
        title: '商品类别/型号',
        render: (h, parms) => {
          return h('div', {
            style: {
              textAlign: 'center'
            }
          }, [
            h('div', parms.row.type),
            h('div', parms.row.category)
          ])
        }
      },
      {
        title: '商品数量',
        key: 'count'
      },
      {
        title: '商品属性',
        key: 'sku_name'
      },
      {
        title: '特殊要求',
        key: 'requirement'
      },
      {
        title: '安装要求',
        align: 'right',
        tooltip: true,
        key: 'install'
      }
      ],
      data: [{
        img: '',
        type: 'AM12312312',
        category: '盖板/普通',
        count: 1,
        sku_name: '嵌入式（壁挂）',
        requirement: '不要敲门',
        install: '需要拆除（玻璃胶）'
      }]
    }
  },
  methods: {
    cancel () {
      let vm = this
      this.$cancelOrder({
        id: vm.id
      }).then(res => {
        console.log(res)
        if (res == 'confirm') {
          console.log('----')
          vm.$message.success('操作成功')
          location.reload()
        }
      })
    },
    changeHandler (value) {
      if (value == 1) {
        this.formItem.money = parseFloat(this.price)
      }
    },
    changeWorkerStar (value) {
      const typeMap = {
        '5': '3',
        '3': '2',
        '1': '1'
      }
      this.formItem.type = typeMap[value] || ''
    },
    setOrderStar (value) {
      this.formItem.order_star = value
    },
    setWorkerStar (key, value) {
      this.formItem[key] = value
    },
    payment () {
      let vm = this
      if (!this.formItem.order_star) {
        return vm.$message.error('请给订单评价打分')
      }
      if (!this.formItem.worker_star) {
        return vm.$message.error('请选择师傅综合评价')
      }
      if (!this.formItem.book_star || !this.formItem.skill_star || !this.formItem.attitude_star || !this.formItem.service_star) {
        return vm.$message.error('请给师傅整体表现打分')
      }
      if (!this.formItem.evaluate) {
        return	vm.$message.error('请输入评价内容')
      }
      if (this.formItem.img.length == 0) {
        return	vm.$message.error('请上传图片')
      }
      this.$util.throttle(() => {
        this.$request('614f7763bbd47', {
          'order_id': vm.id,
          'order_star': vm.formItem.order_star,
          'worker_star': Number(vm.formItem.worker_star),
          'type': vm.formItem.type,
          'book_star': vm.formItem.book_star,
          'skill_star': vm.formItem.skill_star,
          'attitude_star': vm.formItem.attitude_star,
          'service_star': vm.formItem.service_star,
          'evaluate': vm.formItem.evaluate,
          'img': vm.formItem.img
        }).then(res => {
          this.$message.success('提交成功')
          location.reload()
        })
      }, 2000, true)
    },
    gotoPay () {
      console.log('gotoPay')
    }
  }
}
</script>

<style lang="less">
  .order_detail {

    .ivu-steps-title {
      margin-top: 2px;
    }

    .card {
      background-color: #FFFFFF;
      padding: 20px;
      border-radius: 3px;

      .base {
        margin-top: 30px;
        border-radius: 3px;

        .header {
          display: flex;
          justify-content: space-between;

          .left {
            display: flex;
          }

          .status {
            margin-left: 30px;

            .error {
              color: red;
            }
          }

          .right .cancel {
            margin-left: 10px;
          }
        }

        .info {
          margin-top: 10px;

          span {
            margin-right: 40px;
          }
        }
      }

      .title {
        font-size: 18px;
        color: #333;
        font-weight: 450;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 0;
          width: 70px;
          height: 3px;
          background-color: #FB9E2F;
        }
      }

    }

    .block {
      height: 10px;
      background-color: #f7f8fa;
    }

    .step {
      padding: 20px;

      .title {
        margin-bottom: 15px;
        color: rgb(51, 51, 51);
        font-size: 18px;
        margin-right: 12px;
      }
    }

    .user-info {
      padding: 20px;
    }

    .descriptions-label {
      color: #333333;
    }

    .el-descriptions__title {
      color: rgb(51, 51, 51);
      font-size: 18px;
      font-weight: normal;
    }

    .error {
      color: red;
    }

    .evaluate-score {
      margin-bottom: 24px;
      color: #333333;

      .score-section {
        margin-bottom: 22px;
      }

      .score-section-title {
        margin-bottom: 12px;
        color: #333333;
        font-size: 15px;
        font-weight: 600;
      }

      .score-row {
        display: flex;
        align-items: center;
        min-height: 34px;
        margin-bottom: 6px;
        font-size: 14px;
      }

      .score-title {
        display: flex;
        align-items: center;
        margin: 14px 0 8px;
        color: #333333;
        font-size: 14px;
        font-weight: 500;
      }

      .required {
        color: #ff4d4f;
        margin-right: 2px;
        font-weight: 600;
      }

      .score-label {
        width: 104px;
        flex-shrink: 0;
      }

      .flower-rate {
        display: flex;
        align-items: center;
      }

      .flower-rate-item {
        width: 22px;
        height: 22px;
        margin-right: 8px;
        color: #c8cdd3;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        svg {
          width: 22px;
          height: 22px;
          display: block;
        }

        &.active {
          color: #fb9e2f;

          .star-shape {
            fill: currentColor;
          }
        }
      }

      .star-shape {
        stroke: currentColor;
        stroke-width: 1.35;
        stroke-linecap: round;
        stroke-linejoin: round;
        fill: #ffffff;
      }

      .overall-radio {
        display: flex;
        align-items: center;

        .ivu-radio-wrapper {
          display: flex;
          align-items: center;
          margin-right: 38px;
          color: #999999;
          font-size: 15px;
          line-height: 24px;
        }

        .ivu-radio {
          display: none;
        }

        .bouquet-icon {
          width: 21px;
          height: 21px;
          margin-right: 5px;
          color: #a7adb4;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .bouquet-icon svg {
          width: 21px;
          height: 21px;
          display: block;
        }

        .ivu-radio-wrapper-checked {
          color: #fb9e2f;

          .bouquet-icon {
            color: #fb9e2f;
          }

          .star-shape {
            fill: currentColor;
          }
        }
      }

    }
  }
</style>
